import {Pipe, PipeTransform} from '@angular/core';
import {RoleDto} from '../../Models/Core/role.interface';

@Pipe({
  name: 'roles',
  standalone: false,
})
export class RolesPipe implements PipeTransform {

  transform(items: RoleDto[], filter: { level?: number | null }): RoleDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    const {level} = filter;

    if (level) {
      return items.filter((item) => item.nivel > level);
    }

    return items;
  }

}
